import { render, staticRenderFns } from "./PageNotFoundView.vue?vue&type=template&id=2ec1752e"
import script from "./PageNotFoundView.vue?vue&type=script&lang=ts"
export * from "./PageNotFoundView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports